import React,{useState, useEffect, Fragment} from "react";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
import "../../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link,useNavigate } from 'react-router-dom'
import axios from "axios";
import {foreignexchangelists} from '../../../apis/urls'

const AddGisaforeign = () => {

    const [type, setType] = useState('GISA');
    const [name,setName] = useState('');
    const [visa_status,setVisa_status] = useState('');
    const [city,setCity] = useState('');
    const [state,setState] = useState('');
    const [status,setStatus] = useState('');

    const [nameerror,setNameerror] = useState(false);
    const [v_staterror,setV_staterror] = useState(false);
    const [cityerror,setCityerror] = useState(false);
    const [stateerror,setStateerror] = useState(false);


    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/gisapprovelist")
        
    }

    const onFormClick = (type) => {

        let error = 0;

        if(type == 'GISA')
        {
            if(name === '')
            {
                setNameerror(true)
                error = 1;
            }
            if(city === '')
            {
                setCityerror(true)
                error = 1;
            }

            if(state === '')
            {
                setStateerror(true)
                error = 1;
            }
        }else if(type == 'CSIT')
        {
            if(name === '')
            {
                setNameerror(true)
                error = 1;
            }

            if(visa_status === '')
            {
                setV_staterror(true)
                error = 1;
            }

        }

        

        if(error === 0) 
        {

            let token = "Bearer "+localStorage.getItem('token');
            console.log(token)
            const data = {
                type:type,
                name :name,
                visa_status :visa_status,
                city:city,
                state:state,
                status :'ACTIVE'
            }
            
            const instance = axios.create({

                baseURL: foreignexchangelists,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.post('',data).then((response) =>{
                
                let path = 'newPath'; 
                navigate("/gisapprovelist")

            
            }).catch((error) =>{
                
                console.log('error',error.message)

                
            });
        }


    }

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">

                    


                    {/* <div class="radio-btn-options">
                        <label>
                            <input type="radio" checked={type === 'GISA'} name="type" onChange = { e => { setType(e.target.value);  } } value="GISA"/>GISA
                        </label>
                        <label>
                            <input type="radio" checked={type === 'CSIT'} name="type" onChange = { e => { setType(e.target.value);  } } value="CSIT"/>CSIET
                        </label>
				    </div> */}

                   

                    
                        <div className="page-title-wrpr">
                            <div className="page-title-left-column">
                                
                                <h2 className="page-title">New Foreign Exchage Program</h2>
                            </div>
                            <div className="page-rightside-action-column">
                                
                                
                            </div>
                        
                        
                        </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard"> Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/gisapprovelist"> Programs</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Add New</li>
                        </ol>
                    </nav>


                    {
                        type === 'GISA'?
                    

                    (<Fragment>
                    <form className="needs-validation" noValidate>
                        <div className="form-wrpr"> 




                            <div className="card formcard small">
                                <div className="card-body">


                    <div class="radio-btn-optionss">    
                        <label>
                            <input type="radio" checked={type === 'GISA'} name="type" onChange = { e => { setType(e.target.value);  } } value="GISA"/><span></span>GISA
                        </label>
                        <label>
                            <input type="radio" checked={type === 'CSIT'} name="type" onChange = { e => { setType(e.target.value);  } } value="CSIT"/>CSIET
                        </label>
				    </div>

                    
                                    <div className="form-group">
                                        <label className="degreehead">Name<span style={{color: "red"}}>*</span></label>
                                        
                                        <input type="text" className="form-control bg-dark dark-theme showtext" value={name} onChange={e => {setName(e.target.value)}} placeholder="Enter Program  Name" id="name"></input>
                                        {
                                            nameerror
                                            ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Name</div>
                                            :null
                                        }
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            
                                            <div className="col-md-6">
                                                <label className="degreehead">City<span style={{color: "red"}}>*</span></label>
                                                <input type="text" className="form-control bg-dark dark-theme showtext" value={city} onChange={e => {setCity(e.target.value)}} placeholder="Enter the City" id="name"></input>
                                                {
                                                    cityerror
                                                    ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The City</div>
                                                    :null
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                <label className="degreehead">State<span style={{color: "red"}}>*</span></label>
                                                    <select onChange={e => {setState(e.target.value)}} type="password" class="form-control bg-dark" id="state">
                                                        <option>Select State</option>
                                                        <option>SA</option>
                                                        <option>GA</option>
                                                        <option>FA</option>
                                                    </select>
                                                    {
                                                        stateerror
                                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select The State</div>
                                                        :null
                                                    }
                                            </div>
                                        </div>
                                        
                                    </div>
                                    {/* <div className="form-group">
                                    <label className="degreehead">Status</label>
                                        <select onChange={e => {setStatus(e.target.value)}} type="password" class="form-control bg-dark" id="state">
                                            <option >Select Status</option>
                                            <option>ACTIVE</option>
                                            <option>INACTIVE</option>
                                            <option>DELETED</option>

                                        </select>
                                    </div> */}
                                    <h6 style={{color: "red"}}>* Required Fields</h6>
                                    
                                    <div className="form-group text-right">
                                        <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                        <button onClick={()=>{ onFormClick(type) }} className="btn btn-primary btn-gisa" type="button">Create</button>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </form>
                </Fragment>):

                <Fragment>
                    {/* <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Foreign Exchage</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div> */}

                    {/* <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/gisapprovelist"> Programs</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Add New</li>
                        </ol>
                    </nav> */}

                    <form className="needs-validation" noValidate>
                        <div className="form-wrpr">
                            <div className="card formcard small">
                                
                                <div className="card-body">
                                <div class="radio-btn-optionss">
                        <label>
                            <input type="radio" checked={type === 'GISA'} name="type" onChange = { e => { setType(e.target.value);  } } value="GISA"/><span></span>GISA
                        </label>
                        <label>
                            <input type="radio" checked={type === 'CSIT'} name="type" onChange = { e => { setType(e.target.value);  } } value="CSIT"/>CSIET
                        </label>
				    </div>
                                    <div className="form-group">
                                        <label className="degreehead">Name<span style={{color: "red"}}>*</span></label>
                                        <input type="text" className="form-control bg-dark dark-theme showtext" value={name} onChange={e => {setName(e.target.value)}} placeholder="Enter Program  Name" id="name"></input>
                                        {nameerror}
                                        {
                                            nameerror
                                            ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Name</div>
                                            :null
                                        }
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                        
                                            <div className="col-md-6">
                                                <label className="degreehead">Visa Status<span style={{color: "red"}}>*</span></label>
                                                    <select onChange={e => {setVisa_status(e.target.value)}} className="form-control bg-dark" id="state">
                                                        <option>Select Visa status</option>
                                                        <option>J1</option>
                                                        <option>F1</option>
                                                    </select>
                                                    {
                                                        v_staterror
                                                        ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Select Visa Status</div>
                                                        :null
                                                    }
                                            </div>
                                            <div className="col-md-6">
                                                {/* <label className="degreehead">Status</label>
                                                    <select onChange={e => {setStatus(e.target.value)}} className="form-control bg-dark" id="state">
                                                        <option >Select Status</option>
                                                        <option>ACTIVE</option>
                                                        <option>INACTIVE</option>
                                                        <option>DELETED</option>
                                                    </select>     */}
                                            </div>

                                        </div>
                                        <h6 style={{color: "red"}}>* Required Fields</h6>       
                                    </div>
                                    <div className="form-group text-right">
                                        <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                        <button onClick={()=>{ onFormClick(type) }} className="btn btn-primary btn-gisa" type="button">Create</button>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </form>
                </Fragment>
                }


                </div>
            </aside>
        </div>
    )

}

export default AddGisaforeign;
